export default __webpack_public_path__ + "static/media/mobile_links_docs.7ada6be8.svg";